import React from 'react';
import { MinimalLoading } from './minimal-loading';

interface SafeLoadingProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

export const SafeLoading: React.FC<SafeLoadingProps> = ({ 
  className, 
  size = 'md',
  message = 'Carregando...' 
}) => {
  return <MinimalLoading className={className} size={size} message={message} />;
};

export default SafeLoading;
